import { Injectable } from '@angular/core';
import { ComponentStore } from '@ngrx/component-store';

export interface RootState {
  readonly count: number;
}

@Injectable({ providedIn: 'root' })
export class RootStore extends ComponentStore<RootState> {
  constructor() {
    super({ count: 0 });
  }

  readonly count$ = this.select(({ count }) => count);

  readonly incrementCount = this.updater((state) => ({
    ...state,
    count: state.count + 1,
  }));

  readonly setCount = this.updater((state, newCount:number) => ({
    ...state,
    count: newCount,
  }));

  readonly decrementCount = this.updater((state) => ({
    ...state,
    count: state.count - 1,
  }));
}
